import React from 'react';
import TablaFechas from './TablaFechas';
import TablaPedidos from './TablaPedidos';
import TablaUsoColor from './TablaUsoColor';
import TablaValidaciones from './TablaValidaciones';
import TablaTracking from './TablaTracking';
import TablaFacturacion from './TablaFacturacion';

function showTable(that, pedidos) {
  switch (that.activeFilterPedido) {
    case 0:
      return (
        <TablaFechas
          pedidos={pedidos}
          numProfVeh={that.numProforma}
          selectCheckPedidos={that.selectCheckPedidos}
          pedidosConCheck={that.pedidosConCheck}
          selectAll={that.selectAll}
          fdvID ={that.fdvID}
          loading={that.loading}

        />
      );
    case 1:
      return (
        <TablaPedidos
          pedidos={pedidos}
          numProfVeh={that.numProforma}
          selectCheckPedidos={that.selectCheckPedidos}
          pedidosConCheck={that.pedidosConCheck}
          loading={that.loading}
          selectAll={that.selectAll}
          fdvID ={that.fdvID}
          isFinishedAsignacionDefinitiva={that.isFinishedAsignacionDefinitiva}
          doneAsignacionDefinitiva={that.doneAsignacionDefinitiva}
        />
      );
    case 2:
      return (
        <TablaTracking
          pedidos={pedidos}
          numProfVeh={that.numProforma}
          selectCheckPedidos={that.selectCheckPedidos}
          pedidosConCheck={that.pedidosConCheck}
          selectAll={that.selectAll}

        />
      );
    case 3:
      return (
        <TablaFacturacion
          pedidos={pedidos}
          numProfVeh={that.numProforma}
          selectCheckPedidos={that.selectCheckPedidos}
          pedidosConCheck={that.pedidosConCheck}
          selectAll={that.selectAll}
          listaCorreos={that.listaCorreos}//Req 92528 ebarboza 30 08 2021

        />
      );
    case 4:
      return (
      null
      );
    case 5:
      return (
        <TablaUsoColor
          pedidos={pedidos}
          numProfVeh={that.numProforma}
          selectCheckPedidos={that.selectCheckPedidos}
          pedidosConCheck={that.pedidosConCheck}
          selectAll={that.selectAll}

        />
      );
    case 6:
      return (
        <TablaValidaciones
          pedidos={pedidos}
          numProfVeh={that.numProforma}
          selectCheckPedidos={that.selectCheckPedidos}
          pedidosConCheck={that.pedidosConCheck}
          openAlert={that.openAlert}
          changeIndex={that.changeIndex}
        />
      );
    default:
      return null;
  }
}

export default showTable;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/showTable.js